"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateHash = exports.createUUID = void 0;
const helpers_1 = require("../core/helpers");
const uuid_1 = require("uuid");
const createUUID = () => {
    return (0, uuid_1.v4)();
};
exports.createUUID = createUUID;
const generateHash = (length, characters) => {
    let hash = '';
    for (let i = 0; i < length; i += 1) {
        hash += characters.charAt(Math.floor((0, helpers_1.getRandomValueCrypto)() * characters.length));
    }
    return hash;
};
exports.generateHash = generateHash;
//# sourceMappingURL=uuid.js.map